import { client } from "./index";
import { vendor } from "../Constant/index";

export const placeOrder = (payload) => client.post(`order/add`, payload ,  { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

export const createOrder = (payload) => client.post(`order/create-payment-intent`, payload ,  { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });


export const getOrders = () => client.get(`orders/customer`,    { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

export const getOrder = (id) => client.get(`order?id=${id}`,    { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });


export const getSessionOrder = (payload) => client.post(`order/get-session-order`, payload,    { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

export const confirmPayment = (payload) => client.post(`order/confirm-payment`, payload,    { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });








// export const addToCart = (payload) => client.post(`cart`,  payload, { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

